export enum EnumCustomAttributes {
  ENABLE_PAGINATION = "enablePagination",
  ENABLE_PRODUCT_PRICE = "enableProductPrice",
  ENABLE_RESULTS_COUNTER = "enableResultsCounter",
  ENABLE_RESULTS_COUNTER_ON_QUESTIONNAIRE = "enableResultsCounterOnQuestionnaire",
  DISABLE_PRODUCT_CLICKOUT = "productClickoutDisabled",
  SCROLL_MARGIN_TOP = "scrollMarginTop"
}
